export let sideBarData =[
    {value:"2",tittle:"Organization"},
    {value:"3",tittle:"Follow Up"},
    {value:"4",tittle:"Favorites"},
    {value:"5",tittle:"Ideas"},
    {value:"6",tittle:"Important"},
    {value:"7",tittle:"Business"},
    {value:"8",tittle:"Holidays"},
]
export const organizationList = [
    {
      id: "1",
      activeTab: "1",
      avatar: "avatar/6.jpg",
      name: "Mark Jecno",
      email: 'markjecno@gmail.com',
      gender: "Male",
    },
    {
      id: "2",
      activeTab: "2",
      avatar: "user/3.jpg",
      name: "Jason Borne",
      email: "jasonb@gmail.com",
      gender: "Male",
    },
    {
      id: "3",
      activeTab: "3",
      avatar: "user/4.jpg",
      name: "Sarah Loren",
      email: "barnes@gmail.com",
      gender: "Female",
    },
    {
      id: "4",
      activeTab: "4",
      avatar: "user/10.jpg",
      name: "Andew Jon",
      email: "andewjon@gmail.com",
      gender: "Female",
    },
  ];
  